<template>
  <!--==================
    component used in tour add and edit, clone page in photo selection part (gallery)
    ===============-->

  <!-- Modal -->
  <div
    class="modal fade"
    id="destination-image-modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header py-3" style="align-items: center">
          <button v-if="step == 2" @click="beforeStep()" type="button">
            <span><i class="icofont-arrow-left text-danger" style="font-size: 1.40625rem"></i></span>
          </button>
          <h5 class="modal-title">
            Photos
            <span v-if="step == 2 && selectedDestination != ''">for {{ selectedDestination }}</span>
            <span v-if="step == 2 && selectedDestination != '' && !loading">({{ imageLen }})</span>
            <span v-if="this.galleryImagesInModal.length != 0 && isGallery"
              >&nbsp;&nbsp;&nbsp;{{ this.galleryImagesInModal.length }} - image selected</span
            >
          </h5>
          <input
            v-if="step == 1"
            type="text"
            class="ml-5 form-control"
            placeholder="Search destination"
            v-model="keyword"
          />
          <button
            v-if="this.galleryImagesInModal.length != 0 && isGallery"
            @click="saveGallery()"
            type="button"
            class="btn btn-primary ml-5"
            aria-label="Close"
          >
            Select
          </button>
          <button @click="modalClose()" type="button" class="close" aria-label="Close">
            <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row" v-if="step == 1">
            <div
              v-for="(desti, index) in dayDestination"
              :key="index"
              class="col-lg-4 col-md-6 col-xs-6 mt-3 desti"
              @click="fetchPhoto(index)"
            >
              {{ desti.name }}
            </div>
            <div v-if="dayDestination.length == 0">No search result.</div>
          </div>
          <div v-if="isDay">
            <div class="row" v-if="step == 2 && !loading && tourDayPhotos.length > 0">
              <div
                v-for="(photo, index) in tourDayPhotos.slice(
                  (pageNumber - 1) * imagePerPage,
                  pageNumber * imagePerPage
                )"
                :key="index"
                class="col-lg-4 col-md-6 col-xs-6 thumb"
              >
                <img @click="tourBannerDay($event)" :src="photo.filepath" class="zoom img-fluid c-pointer" />
              </div>
            </div>
            <paginate
              v-if="step == 2 && !loading && tourDayPhotos.length > 0"
              v-model="pageNumber"
              :page-count="Math.ceil(tourDayPhotos.length / imagePerPage)"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-link-class="'page-link'"
            />
            <div v-if="step == 2 && !loading && tourDayPhotos.length == 0">
              There are no images yet for this destination.
            </div>
            <div v-if="loading">Loading images...</div>
          </div>

          <div v-else-if="isTour">
            <div class="row" v-if="step == 2 && !loading && tourPhotos.length > 0">
              <div
                v-for="(photo, index) in tourPhotos.slice((pageNumber - 1) * imagePerPage, pageNumber * imagePerPage)"
                :key="index"
                class="col-lg-4 col-md-6 col-xs-6 thumb"
              >
                <img @click="tourBannerDay($event)" :src="photo.filepath" class="zoom img-fluid c-pointer" />
              </div>
            </div>
            <paginate
              v-if="step == 2 && !loading && tourPhotos.length > 0"
              v-model="pageNumber"
              :page-count="Math.ceil(tourPhotos.length / imagePerPage)"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-link-class="'page-link'"
            />
            <div v-if="step == 2 && !loading && tourPhotos.length == 0">
              There are no images yet for this destination.
            </div>
            <div v-if="loading">Loading images...</div>
          </div>

          <div v-else-if="isTourInner">
            <div class="row" v-if="step == 2 && !loading && tourInnerPhotos.length > 0">
              <div
                v-for="(photo, index) in tourInnerPhotos.slice(
                  (pageNumber - 1) * imagePerPage,
                  pageNumber * imagePerPage
                )"
                :key="index"
                class="col-lg-4 col-md-6 col-xs-6 thumb"
              >
                <img @click="tourBannerDay($event)" :src="photo.filepath" class="zoom img-fluid c-pointer" />
              </div>
            </div>
            <paginate
              v-if="step == 2 && !loading && tourInnerPhotos.length > 0"
              v-model="pageNumber"
              :page-count="Math.ceil(tourInnerPhotos.length / imagePerPage)"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-link-class="'page-link'"
            />
            <div v-if="step == 2 && !loading && tourInnerPhotos.length == 0">
              There are no images yet for this destination.
            </div>
            <div v-if="loading">Loading images...</div>
          </div>

          <div v-else-if="isGallery">
            <div class="row" v-if="step == 2 && !loading && tourGalleryPhotos.length > 0">
              <div
                v-for="(photo, index) in tourGalleryPhotos"
                :key="index"
                class="col-lg-4 col-md-6 col-xs-6 thumb position-relative"
              >
                <img
                  @click="tourBannerDay($event)"
                  v-lazy="{
                    src: photo.filepath,
                    error: require('@/assets/images/no-thumbnail-medium.jpg'),
                    loading: require('@/assets/images/no-thumbnail-medium.jpg'),
                  }"
                  class="img-fluid c-pointer"
                />
                <input
                  type="checkbox"
                  :value="photo.filepath"
                  v-model="galleryImagesInModal"
                  class="position-absolute top-0 right-0 mr-5 mt-3"
                />
              </div>
            </div>

            <!-- poagination code -->

            <!-- <div v-else-if="isGallery">
            <div class="row" v-if="step == 2 && !loading && tourGalleryPhotos.length > 0">
              <div
                v-for="(photo, index) in tourGalleryPhotos.slice(
                  (pageNumber - 1) * imagePerPage,
                  pageNumber * imagePerPage
                )"
                :key="index"
                class="col-lg-4 col-md-6 col-xs-6 thumb"
              >
                <img @click="tourBannerDay($event)" :src="photo.filepath" class="zoom img-fluid c-pointer" />
              </div>
            </div>
            <paginate
              v-if="step == 2 && !loading && tourGalleryPhotos.length > 0"
              v-model="pageNumber"
              :page-count="Math.ceil(tourGalleryPhotos.length / imagePerPage)"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-link-class="'page-link'"
            /> -->
            <div v-if="step == 2 && !loading && tourGalleryPhotos.length == 0">
              There are no images yet for this destination.
            </div>
            <div v-if="loading">Loading images...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";

export default {
  data() {
    return {
      step: 1,
      loading: false,
      selector: "",
      selectedDestination: "",
      daySelector: 0,
      imageLen: 0,

      isDay: false,
      isTour: false,
      isTourInner: false,
      isGallery: false,

      //for pagination
      pageNumber: 1,
      imagePerPage: 6,
      galleryImagesInModal: [],
      dayDestination: [],

      keyword: "",
    };
  },

  components: {
    Paginate,
  },

  computed: {
    ...mapGetters(["tourDestinations", "tourPhotos", "tourDayPhotos", "tourGalleryPhotos", "tourInnerPhotos"]),
  },

  watch: {
    keyword: function () {
      if (this.keyword && this.tourDestinations != undefined) {
        this.dayDestination = this.tourDestinations.filter((item) => {
          return this.keyword
            .toLowerCase()
            .split(" ")
            .every((v) => item.name.toLowerCase().includes(v));
        });
      } else {
        this.dayDestination = this.tourDestinations;
      }
    },
  },

  mounted() {
    setTimeout(() => {
      this.dayDestination = this.tourDestinations;
    }, 2000);

    this.$eventHub.$on("gallery", (selector, daySelector) => {
      this.selector = selector;
      this.daySelector = daySelector;
      if (this.selector == "tour-day-gallery") {
        this.isDay = true;
        this.isTour = false;
        this.isTourInner = false;
        this.isGallery = false;
      } else if (this.selector == "tour-thumb") {
        this.isDay = false;
        this.isTour = true;
        this.isTourInner = false;
        this.isGallery = false;
      } else if (this.selector == "tour-banner") {
        this.isDay = false;
        this.isTour = false;
        this.isTourInner = true;
        this.isGallery = false;
      } else if (this.selector == "tour-gallery") {
        this.isDay = false;
        this.isTour = false;
        this.isTourInner = false;
        this.isGallery = true;
      }
    });
  },

  methods: {
    ...mapActions(["fetchTourPhotos", "fetchTourDayPhotos", "fetchTourGalleryPhotos", "fetchTourInnerPhotos"]),

    fetchPhoto(index) {
      this.selectedDestination = this.dayDestination[index].name;
      const dest = this.dayDestination[index].name.toUpperCase().replace(/\s+/g, "_");
      this.filterPhoto(dest);
      this.step = 2;
    },

    async filterPhoto(destination) {
      this.loading = true;
      if (this.isDay)
        await this.fetchTourDayPhotos(destination).then(() => {
          this.loading = false;
          this.imageLen = this.tourDayPhotos.length;
        });
      else if (this.isTour)
        await this.fetchTourPhotos(destination).then(() => {
          this.loading = false;
          this.imageLen = this.tourPhotos.length;
        });
      else if (this.isTourInner)
        await this.fetchTourInnerPhotos(destination).then(() => {
          this.loading = false;
          this.imageLen = this.tourInnerPhotos.length;
        });
      else if (this.isGallery)
        await this.fetchTourGalleryPhotos(destination).then(() => {
          this.loading = false;
          this.imageLen = this.tourGalleryPhotos.length;
        });
    },

    tourBannerDay(e) {
      let image = e.target.src;
      let day = this.daySelector;
      if (this.isDay) this.$eventHub.$emit("day-gallery-photo", image, day);
      else if (this.isTour) this.$eventHub.$emit("tour-gallery-photo", image);
      else if (this.isTourInner) this.$eventHub.$emit("banner-gallery-photo", image);
      else if (this.isGallery) {
        this.selectTourGallery(image);
        return;
      }
      this.modalClose();
      this.step = 1;
      this.pageNumber = 1;
    },

    beforeStep() {
      this.step = 1;
      this.pageNumber = 1;
      this.galleryImagesInModal = [];
    },

    selectTourGallery(image) {
      const pageNumber = this.pageNumber;
      if (this.galleryImagesInModal.includes(image)) {
        var index = this.galleryImagesInModal.indexOf(image);
        if (index !== -1) {
          this.galleryImagesInModal.splice(index, 1);
        }
        return;
      }
      this.galleryImagesInModal.push(image);
      this.pageNumber = pageNumber;
    },

    saveGallery() {
      this.$eventHub.$emit("add-gallery-photo", this.galleryImagesInModal);
      this.modalClose();
      this.galleryImagesInModal = [];
    },

    modalClose() {
      $("#destination-image-modal").modal("hide");
      this.step = 1;
      this.pageNumber = 1;
      this.keyword = "";
    },

    sliceString(value) {
      return value.substring(value.lastIndexOf("/") + 1);
    },
  },
};
</script>
<style scoped>
.desti:hover {
  text-decoration: underline;
  cursor: pointer;
}
.pagination {
  justify-content: center;
  align-items: center;
}

.modal-body {
  max-height: 80vh;
  overflow-y: scroll;
}
/* #destination-image-modal .modal-body {
  height: 400px;
  overflow: auto;
} */
</style>